import { useCallback, useState } from 'react';
import moment from 'moment';
import { Form, Input, Button, DatePicker } from 'antd';
import { expressDescSteps } from './enums.js';
import { addExpressMaterialTask } from '../../../../service/expressMaterial';


const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current < moment().endOf('day');
};

// 联系客户
export default function ContactForm(props) {
  const [contactLoading, setContactLoading] = useState(false);

  // 提交沟通客户
  const onSubmitContact = useCallback(async (values) => {
    const { flowId } = props;
    setContactLoading(true);
    const { nextDate, ...otherValues } = values;
    try {
      const { result } = await addExpressMaterialTask(flowId, {
        content: expressDescSteps.checkAgent,
        nextDate: nextDate.valueOf(),
        ...otherValues
      })
      props.onSuccess && props.onSuccess(result);
    } catch { };
    setContactLoading(false);
  }, [props]);

  const onCancel = useCallback(() => props.onCancel && props.onCancel(), [props]);

  return <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onFinish={onSubmitContact}>
    <Form.Item name="nextDate" label="下次追踪" rules={[{ required: true, message: '请选择追踪时间' }]}>
      <DatePicker showTime style={{ width: '100%' }} disabledDate={disabledDate} />
    </Form.Item>
    <Form.Item name="remark" label="备注">
      <Input.TextArea maxLength={500} placeholder="请输入描述说明, 500字内" style={{ height: 80 }} />
    </Form.Item>
    <Form.Item className="align-right" style={{ marginBottom: 0 }} wrapperCol={{ offset: 4, span: 20 }}>
      <Button className="margin-right" onClick={onCancel}>取消</Button>
      <Button type="primary" htmlType="submit" loading={contactLoading}>确定</Button>
    </Form.Item>
  </Form>
}